import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index.vue'


Vue.use(Router)

const router = new Router({
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: () =>
        import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
      meta: { title: '金梨餐饮', hidden: true, notNeedAuth: true }
    },
    {
      path: '/404',
      component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
      meta: { title: '金梨餐饮', hidden: true, notNeedAuth: true }
    },
    {
      path: '/',
      component: Layout,
      redirect: '/dashboard',
      children: [
        {
          path: 'dashboard',
          component: () =>
            import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue'),
          name: 'Dashboard',
          meta: {
            title: '工作台',
            icon: 'dashboard',
            affix: true
          },

        },
        {
          path: '/statistics',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/statistics/index.vue'),
          meta: {
            title: '数据统计',
            icon: 'icon-statistics'
          },
        },
        // {
        //   path: 'material',
        //   component: () =>
        //     import(/* webpackChunkName: "shopTable" */ '@/views/material/index.vue'),
        //   meta: {
        //     title: '材料管理',
        //     icon: 'icon-statistics'
        //   },
        //
        // },
        // {
        //   path: 'warehouse',
        //   component: () =>
        //     import(/* webpackChunkName: "shopTable" */ '@/views/warehouse/index.vue'),
        //   meta: {
        //     title: '仓库管理',
        //     icon: 'icon-school'
        //   },
        //   role: [0]
        // },
        {
          path: 'shop',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/shop/index.vue'),
          meta: {
            title: '门店管理',
            icon: 'icon-school'
          },

        },
        {
          path: 'order',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/orderDetails/index.vue'),
          meta: {
            title: '订单管理',
            icon: 'icon-order'
          },

        },
        {
          path: 'setmeal',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/setmeal/index.vue'),
          meta: {
            title: '套餐管理',
            icon: 'icon-combo'
          },

        },
        {
          path: 'dish',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/dish/index.vue'),
          meta: {
            title: '菜品管理',
            icon: 'icon-dish'
          },

        },
        {
          path: '/dish/add',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/dish/addDishtype.vue'),
          meta: {
            title: '添加菜品',
            hidden: true
          },

        },
        {
          path: '/shop/add',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/shop/addShop.vue'),
          meta: {
            title: '添加店铺 ',
            hidden: true
          },

        },
        {
          path: 'category',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/category/index.vue'),
          meta: {
            title: '分类管理',
            icon: 'icon-category'
          },

        },
        {
          path: 'employee',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/employee/index.vue'),
          meta: {
            title: '员工管理',
            icon: 'icon-employee'
          },
        },

        {
          path: '/employee/add',
          component: () =>
            import(/* webpackChunkName: "dashboard" */ '@/views/employee/addEmployee.vue'),
          meta: {
            title: '添加员工',
            hidden: true
          },

        },

        {
          path: '/setmeal/add',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/setmeal/addSetmeal.vue'),
          meta: {
            title: '添加套餐',
            hidden: true
          },

        },
        {
          path: '/material/add',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/material/addMaterial.vue'),
          meta: {
            title: '添加材料',
            hidden: true
          },

        },
        {
          path: '/warehouse/add',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/warehouse/addWarehouse.vue'),
          meta: {
            title: '添加仓库',
            hidden: true
          },

        },
        {
          path: '/warehouse/store',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/warehouse/store.vue'),
          meta: {
            title: '采购',
            hidden: true
          },

        },
        {
          path: '/warehouse/give',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/warehouse/give.vue'),
          meta: {
            title: '送货',
            hidden: true
          },

        },{
          path: '/warehouse/record',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/warehouse/record.vue'),
          meta: {
            title: '查看库存记录',
            hidden: true
          },

        },{
          path: '/warehouse/recordDetail',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/warehouse/recordDetail.vue'),
          meta: {
            title: '查看库存记录详情',
            hidden: true
          },

        },{
          path: '/warehouse/inventory',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/warehouse/inventory.vue'),
          meta: {
            title: '查看库存',
            hidden: true
          },
        }
      ]
    },
    {
      path: '*',
      redirect: '/404',
      meta: { hidden: true }
    }
  ]
})

export default router
